let BASE_URL = "//api.vhallyun.com/sdk/v2";
let SaasBaseUrl = "//saas-api.vhall.com";

/**
 * 问卷环境设置
 * 2024-06-21 增加env参数，用于paasapi判断是否测试环境
 * @param {String} env
 * @param {String|undefined} saasBaseUrl
 */
export const setEnv = (options) => {
  if (typeof options === "string") {
    // 如果只是字符串，说明是旧版，传过来的是saasBaseUrl,这里做旧版逻辑兼容处理
    if (options) {
      // prettier-ignore
      BASE_URL = options.indexOf("test") > -1 ? "//test01-api.vhallyun.com/sdk/v2" : BASE_URL;
      SaasBaseUrl = options;
    }
  } else if (options && typeof options === "object") {
    if (options.env === "test") {
      BASE_URL = "//test01-api.vhallyun.com/sdk/v2";
    }
  }
};

/**
 * 处理saasBaseUrl
 * 支持saasBaseUrl传空字符串，以实现请求同源
 * @param {String|undefined} saasBaseUrl
 * @returns
 */
export const handleSaasBaseUrl = (saasBaseUrl) => {
  // 如果想saasBaseUrl用默认值，建议传undefined; 传''实现请求同源
  if (typeof saasBaseUrl === "string") {
    SaasBaseUrl = saasBaseUrl;
  }
  return SaasBaseUrl;
};

export default {
  // 获取地区数据
  GET_AREA_JSON: "https://static.vhallyun.com/public/static/js/area.json",
  // 创建问卷
  POST_CREATE_QUESTIONNAIRE: () => `${BASE_URL}/datacollect/index-create`,
  // 更新问卷
  POST_UPDATE_QUESTIONNAIRE: () => `${BASE_URL}/datacollect/index-update`,
  // 获取单个问卷
  GET_QUESTIONNAIRE_ID: () => `${BASE_URL}/datacollect/index-get`,
  // 批量获取问卷
  GET_QUESTIONNAIRE_IDS: () => `${BASE_URL}/datacollect/index-list-by-ids`,
  //提交问卷
  POST_SUBMIT_QUESTIONNAIRE: () => `${BASE_URL}/answer/create`,
  // POST_SUBMIT_QUESTIONNAIRE: `${BASE_URL}/answer-add`,
  //发布问卷
  POST_PUBLISH_QUESTIONNAIRE: () => `${BASE_URL}/datacollect/index-publish`,
  //取消发布问卷
  POST_CANCEL_PUBLISH_QUESTIONNAIRE: () =>
    `${BASE_URL}/datacollect/index-cancel-publish`,
  // 发送手机验证码
  POST_sendPhoneCode: () => `${SaasBaseUrl}/v3/vss/verify-code/send-by-phone`,
  // 校验手机验证码
  POST_validatorPhoneCode: () =>
    `${SaasBaseUrl}/v3/vss/verify-code/check-by-phone`,
};
